import React from "react";
import { Link } from "react-router-dom";
import unauthorized from "../../assets/unauthorized.webp";
import "./UnAuthorizedPage.scss";

const UnAuthorizedPage = () => {
  return (
    <div className="user_unauthorized__container">
      <img
        src={unauthorized}
        className="user_unauthorized__container--image"
        style={{
          minHeight: "100vh",
        }}
      />
      <div className="user_unauthorized__message">
        <h2>Dear user</h2>
        <p>
          You have not accepted the legal terms and conditions to access the
          site or you do not have the sufficeient permissions to access the
          site. To accept terms and conditions please contact administrator.If
          you need access, request your permissions through IMDL with the
          appropriate access.
        </p>
        <p className="imdl__link">
          Plese follow the link
          <span>
            <a
              href="http://imdl.app.pmi/IMDLRequest"
              target="_blank"
              rel="noopener noreferrer"
            >
              http://imdl.app.pmi/IMDLRequest
            </a>
          </span>
        </p>
      </div>
    </div>
  );
};

export default UnAuthorizedPage;
